"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_FREIGHT_CLASSES = exports.ALL_FREIGHT_CLASSES_WITH_NMFC = void 0;
exports.ALL_FREIGHT_CLASSES_WITH_NMFC = [
    "400",
    "300",
    "250",
    "175",
    "125",
    "100",
    "92.5",
    "85",
    "70",
    "65",
    "60",
];
exports.ALL_FREIGHT_CLASSES = [
    ...exports.ALL_FREIGHT_CLASSES_WITH_NMFC,
    "50",
    "55",
    "77.5",
    "110",
    "150",
    "200",
    "500",
];
//# sourceMappingURL=FreightClass.js.map